module.exports = __webpack_public_path__ + "static/customer-notification@3x-c3bdcbc169f4fc4b9e9bf80e449b6826.png";